import React from "react";
import styled, { css, keyframes } from "styled-components";

/** 9×8 도트 하트. on 이면 꽉 찬 하트, 아니면 테두리 도트만. */
const GRID = [
  ".XX...XX.",
  "XXXX.XXXX",
  "XXXXXXXXX",
  "XXXXXXXXX",
  ".XXXXXXX.",
  "..XXXXX..",
  "...XXX...",
  "....X....",
];
const W = GRID[0].length;
const H = GRID.length;
const filled = (x, y) => GRID[y]?.[x] === "X";
const CELLS = [];
GRID.forEach((row, y) =>
  row.split("").forEach((c, x) => {
    if (c !== "X") return;
    const edge = !filled(x - 1, y) || !filled(x + 1, y) || !filled(x, y - 1) || !filled(x, y + 1);
    CELLS.push({ x, y, edge });
  })
);
// 터질 때 튀어나가는 작은 도트 (방향 x, y)
const SPARKS = [
  [-1, -1], [1, -1], [-1.3, 0.2], [1.3, 0.2], [0, -1.4],
];

export const PixelHeart = ({ on, size = 30, color = "#F5931F", line = "currentColor", pop = 0 }) => (
  <Wrap style={{ width: size, height: (size * H) / W }} aria-hidden="true">
    <Svg key={`${on}-${pop}`} viewBox={`0 0 ${W} ${H}`} $on={on} $animate={pop > 0} shapeRendering="crispEdges">
      {CELLS.filter((c) => on || c.edge).map((c) => (
        <rect key={`${c.x}-${c.y}`} x={c.x} y={c.y} width="1" height="1" fill={on ? color : line} />
      ))}
      {on && <rect x="1" y="1" width="1" height="1" fill="#fff" opacity="0.85" />}
    </Svg>
    {on && pop > 0 &&
      SPARKS.map(([dx, dy], i) => (
        <Spark
          key={`${pop}-${i}`}
          style={{ "--dx": `${dx * size * 0.75}px`, "--dy": `${dy * size * 0.75}px`, background: color, width: size / 9, height: size / 9 }}
        />
      ))}
  </Wrap>
);

const popIn = keyframes`
  0%   { transform: scale(0.6); }
  50%  { transform: scale(1.3); }
  100% { transform: scale(1); }
`;
const popOut = keyframes`
  0%   { transform: scale(1.1); }
  100% { transform: scale(1); }
`;
const fly = keyframes`
  0%   { transform: translate(-50%, -50%); opacity: 1; }
  100% { transform: translate(calc(-50% + var(--dx)), calc(-50% + var(--dy))); opacity: 0; }
`;

const Wrap = styled.span`
  position: relative;
  display: inline-block;
`;
const Svg = styled.svg`
  display: block;
  width: 100%;
  height: 100%;
  ${(p) =>
    p.$animate &&
    css`
      animation: ${p.$on ? popIn : popOut} 0.36s steps(4, end) both;
    `}
  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`;
const Spark = styled.i`
  position: absolute;
  left: 50%;
  top: 45%;
  animation: ${fly} 0.5s steps(5, end) both;
  @media (prefers-reduced-motion: reduce) {
    display: none;
  }
`;
